var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUser = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256,296.4c79.5,0,144-64.5,144-144s-64.5-144-144-144s-144,64.5-144,144S176.5,296.4,256,296.4z M161.4,311.6 c-89.1,0-161.3,72.2-161.3,161.3c0,16.9,13.8,30.7,30.7,30.7h450.4c16.9,0,30.7-13.8,30.7-30.7c0-89.1-72.2-161.3-161.3-161.3 L161.4,311.6L161.4,311.6z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUser);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/User.8ccddf990c4ada5cda88e3d40ea4cb5e.svg";